import axiosInstance from '../main/axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import configLocal from '../configuracao/configLocal';
import userLocal from '../configuracao/userLocal';

const ERRO_GERAL_FETCH_LIMIT = 5000;

export function getList(page, sorted, filtered, dataInicio, dataFim) {
  const email = userLocal.getUserConfig('email');
  const grupoId = configLocal.getConfig('grupo');
  const controladorNumero = configLocal.getConfig('numCont');
  const filterPayload = Array.isArray(filtered)
    ? filtered.map(item => (typeof item === 'string' ? item : JSON.stringify(item)))
    : [];

  const params = {
    page: 0,
    perPage: ERRO_GERAL_FETCH_LIMIT,
    email,
    grupo_id: grupoId || '',
    controlador_id: controladorNumero || '',
    data_inicio: dataInicio || '',
    data_fim: dataFim || '',
  };

  if (sorted && sorted.length) {
    params.sort = JSON.stringify(sorted[0]);
  }
  if (filterPayload.length) {
    params.filter = filterPayload;
  }

  const request = axiosInstance
    .get(`/controladoreserrogeral`, {
      params,
    })
    .catch(error => ({
      data: {
        list: [],
        total: 0,
        grupos: [],
        controladores: [],
        error: error.response && error.response.data ? error.response.data.errors : ['Erro ao carregar erros gerais'],
      },
    }));

  return {
    type: 'CONTROLADOR_ERRO_GERAL_FETCHED',
    payload: request,
  };
}

export function getErrosList(filtro) {
  const dataIni = filtro.dataInicial;
  const dataFim = filtro.dataFinal;
  const grupo = configLocal.getConfig('grupo');
  const email = userLocal.getUserConfig('email');

  let url = `/controladoreserrogeral/${dataIni}/${dataFim}/${grupo}`;
  if (filtro.controlador !== null) {
    var cont = filtro.controlador;
    url += `/${cont}`;
  }

  const request = axiosInstance.get(url, {
    params: { email },
  });

  return {
    type: 'CONTROLADOR_ERRO_GERAL_GRAFICO_FETCHED',
    payload: request,
  };
}

export function init() {
  return [showTabs('tabList', 'tabGraph'), selectTab('tabList')];
}
